export const HANDBOOK_TYPES = {
    INDIVIDUAL: 'Individual Handbook',
    LINKED: 'Linked Handbook',
    TEMPLATE: 'Template Handbook',
};

export const CUSTOM_TITLE_TYPES = {
    POLICY: 'policy',
    SECTION: 'section',
};

const HANDBOOK = {
    HANDBOOK_CREATE: {
        event: 'Handbook Create',
        eventProperties: {
            description: 'User created handbook',
        },
    },
    HANDBOOK_POLICY_ALERT: {
        event: 'Handbook Policy Alert Click',
        eventProperties: {
            description: 'User clicked on policy alert handbook',
        },
    },
    HANDBOOK_POLICY_ALERT_ACCEPTED: {
        event: 'Handbook Policy Alert Accept Click',
        eventProperties: {
            description: 'User clicked on policy accept handbook',
        },
    },
    HANDBOOK_POLICY_DISMISS_ALERT: {
        event: 'Handbook Policy Alert Dismiss Click',
        eventProperties: {
            description: 'User clicked on policy dismiss handbook',
        },
    },
    CUSTOM_COMPANY_TERM_SAVED: {
        event: 'Custom Company Term Saved',
        eventProperties: {
            description: 'Admin saved a custom company reference term',
        },
    },
    CUSTOM_TITLE_SAVED: {
        event: 'Custom Title Saved',
        eventProperties: {
            description: 'Admin saved a custom policy or section title',
        },
    },
    AUTOSAVE_TOGGLED_OFF: {
        event: 'Auto-save Toggled Off',
        eventProperties: {
            description: 'User toggled auto-save from on to off in the policy editor',
        },
    },
};

export default HANDBOOK;
